// React
import { useState, useEffect } from 'react'

// Shared
import moment from 'shared/lib/moment'
import { Settings as SettingsUtils, Format as FormatUtils } from 'back_office/v2/utils/utils'

export const getColumnsCount = () => {
  const increment = SettingsUtils.get('store.time_increment')

  switch (increment) {
    case 15:
      return 4
    case 30:
      return 2
    case 60:
      return 1
    default:
      return 1
  }
}

const getLabel = (date) => {
  const format = FormatUtils.dateFormat('time')

  if (!moment.isMoment(date)) return moment(date, 'HH:mm').format(format)

  return date.format(format)
}

export const useTimeOptions = ({
  isTimeSelectable,
  disabledTimes,
  disabled,
  field,
  everythingIsSelectable,
  intervalInMinutes = 15,
  operatingRules,
  from,
  to
}) => {
  const [options, setOptions] = useState([])

  const calculateOptions = () => {
    const result = []

    if (disabled && field?.value) {
      // Field is disabled but has a value
      // Add value to options so it gets displayed
      setOptions([{ label: getLabel(field.value), value: field.value }])
    }

    if (disabled) return

    for (let hour = 0; hour < 24; hour++) {
      for (let minutes = 0; minutes < 60; minutes = minutes + intervalInMinutes) {
        const time = moment().hour(hour).minute(minutes)

        if (disabledTimes?.before) {
          const time = moment(disabledTimes.before).hour(hour).minute(minutes)
          const beforeTime = moment(disabledTimes.before)

          if (time < beforeTime) {
            continue
          }
        }

        if (disabledTimes?.after) {
          const time = moment(disabledTimes.after).hour(hour).minute(minutes)
          const afterTime = moment(disabledTimes.after)

          if (time > afterTime) {
            continue
          }
        }

        const label = getLabel(time)
        const value = time.format('HH:mm')

        if (everythingIsSelectable) {
          result.push({ label, value })
        }

        if (isTimeSelectable && isTimeSelectable(value)) {
          result.push({ label, value })
        }
      }
    }

    setOptions(result)
  }

  useEffect(() => {
    calculateOptions()
  }, [])

  useEffect(() => {
    calculateOptions()
  }, [from?.getTime(), to?.getTime(), operatingRules, intervalInMinutes, disabled, isTimeSelectable])

  return options
}
